// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Image from "next/image.js";
import Button from "../CustomButtons/Button.js";

// sections for this page
import ForumsMeetApprenticesPanel from "../ForumsMeetApprenticesPanel/ForumsMeetApprenticesPanel";
import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

// local assets
import followIcon from "../../public/img/forums/icons/followIcon.png";
import {useForumsSubscribeRequest} from "../../request/api";
import {useForumContext} from "../../contexts/forum";
import {useTopicContext} from "../../contexts/topic";
import {generateTimeAgo} from "../../util/date";
import Link from "next/link";
import {buildSlug, updateQueryString} from "../../util/url";
import {useRouter} from "next/router";
import {useAuthContext} from "../../contexts/auth";

const useStyles = makeStyles()(styles);

export default function ForumsSidePanel(props) {
    const router = useRouter();
    const { auth } = useAuthContext();
    const { classes, cx } = useStyles();
    const data = props.data;
    const postView = props.postView;
    const tag = props.tag;

    const { reloadForums, forums } = useForumContext();
    const { topic } = useTopicContext() ?? {};

    const apprentices = data?.category?.guestPosters.filter(apprentice => apprentice.active);
    
    const {
        isMutating: isSubscribing,
        trigger: subscribe,
        error: subscribeError,
    } = useForumsSubscribeRequest({
        type: "sub category",
        entityId: data?.category?.subCatId,
    }, undefined, {
        withCredentials: true,
    });

    const handleFollow = async () => {
        if (auth.user == null) {
            await router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
        }
        else {
            await subscribe();
            await reloadForums();
        }
    }

    const handleLoginClick = async () => {
        await router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
    } 

    const handleSignupClick = async () => {
        await router.push(updateQueryString(updateQueryString(router.asPath, "register", null), "redirectUrl", router.asPath));
    }

    return (
        <div className={classes.forumSidePanel}>
            {(postView && topic?.relatedPosts.length > 0) && 
            <div className={classes.forumSidePanelBox + " " + (auth.user != null ? "" : classes.desktopView)}>
                {(auth.user != null ?
                <>
                <h1 className={classes.forumSidePanelTitle}>Related posts</h1>
                {(topic?.relatedPosts ?? []).map((post, index) => {
                    return (
                        <div className={classes.forumSidePanelPost} key={index}>
                            <p className={classes.forumSidePanelPostTitle}>
                                <Link href={`/community/${buildSlug(forums?.category?.name)}-${post.subCatId}/topic/${buildSlug(post.topicTitle)}-${post.topicId}`}>
                                    {post.topicTitle}
                                </Link>
                            </p>
                            <p className={classes.forumSidePanelPostText}>in {forums?.category?.name} Community {generateTimeAgo(post.createdDate)}</p>
                        </div>
                    )
                })}
                </>
                :
                <>
                <h1 className={classes.forumSidePanelTitle}>Sign up or login</h1>
                <p className={classes.forumSidePanelText}>It seems you're not a member yet. Why don't you register for a new account or login?</p>
                <div className={classes.forumSidePanelButtons}>
                <Button className={cx(classes.darkButton + " " + classes.signUpButton)} onClick={(e) => handleSignupClick(e)}>Sign up</Button>
                <Button className={cx(classes.outlineButton + " " + classes.signUpButton)} onClick={(e) => handleLoginClick(e)}>Login</Button>
                </div>
                </>
                )}
            </div>}
            {!postView && apprentices.length > 0 &&
                <div className={cx(classes.forumSidePanelBox + " " + classes.desktopView)}>
                    <ForumsMeetApprenticesPanel data={data} apprentices={apprentices} />
                </div>
            }
            {forums?.popularTags && <div className={classes.forumSidePanelBox}>
                <h1 className={classes.forumSidePanelTitle}>Popular Tags</h1>
                <p className={classes.forumSidePanelText}>Discover the popular topics in the {forums?.category?.name} Community by exploring our popular tags.</p>
                <div className={classes.forumSidePanelTags}>
                    {forums?.popularTags.map(({ name }) => {
                        return (
                            <Link href={`/community/${buildSlug(forums.category.name)}-${forums.category.subCatId}/search/?tag=` + encodeURIComponent(name)} className={classes.forumSidePanelTagText + (tag === name ? " " + classes.darkButton : "")} key={name}>{name}</Link>
                        )
                    })}
                </div>
            </div>}
            <div className={classes.forumSidePanelBox}>
                <Image className={classes.forumSidePanelIcon} src={followIcon} alt={"follow-icon"} width={30} height={30} />
                <h1 className={classes.forumSidePanelTitle}>{forums?.isSubscribed ? 'Following' : 'Follow'} {forums?.category?.name} Community</h1>
                <p className={classes.forumSidePanelText}>{forums?.isSubscribed ? 'You will get' : 'Get'} notifications when a new question is posted to the community.</p>
                <Button className={cx(classes.darkButton + " " + classes.mediumButton)} onClick={handleFollow}>{
                    forums?.isSubscribed ? <>
                        {isSubscribing ? 'Unfollowing...' : 'Unfollow'}
                    </> : <>
                        {isSubscribing ? 'Following...' : 'Follow +'}
                    </>
                }</Button>
            </div>
        </div>
    )
}

